let inited = false;

module.exports = rule => {
	if (!inited) {
		rule.pm.handleEvent('@parent ~.Join_Form #prepareTransactionApi', 'inited', (p, widget) => {
			rule.guestMethod = widget.getOption('method');

			if (!rule.transactioApiMethod) {
				rule.transactioApiMethod = rule.guestMethod;
			}

			widget.removeOption('method');

			Object.defineProperty(widget.options, 'method', {
				enumerable: true,
				get: () => rule.transactioApiMethod
			});
		}, {
			prefix: 'rule_transaction_api_method',
			sync: true
		});

		inited = true;
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/guest/register-joinform-prepareapi.es.js